import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../Components/MultiRangeSlider";
const GeneralLedger = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec mb-1 mt-3">
                  <div className="row justify-content-between align-items-center">
                    <div className="col-md-6 col-10">
                      <h4 className="event-alert br-btm-0">
                        General Ledger
                        <div className="clear"></div>
                      </h4>
                    </div>

                    <div className="col-md-4 col-2 align-right">
                      <div className="field text-right">
                        <button
                          class="btn green-btn-revert download-icon mx-0"
                          id="addCount"
                          type="button"
                        >
                          <i class="i-icon"> </i> Download
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass top_filters orderpayy mb-3 mt-2">
                <h4 class="event-alert py-0 my-2">Filters </h4>
                <div className="row mx-0">
                  <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                    <div class="calander d-flex align-items-center">
                      <div class="datePicker pading_right">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="from_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-01"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      <div class="datePicker pading_lect">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="to_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-13"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0">
                    <MultiRangeSlider
                      min={0}
                      max={1000}
                      onChange={({ min, max }) =>
                        console.log(`min = ${min}, max = ${max}`)
                      }
                    />
                  </div>
                  <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                    <div class="select-div col px-1 pl-md-0">
                      <div class="input select">
                        <select
                          name="type"
                          class="csutom_select"
                          id="OrdersType"
                        >
                          <option value="">Asset Type</option>
                          <option value="38130">
                            WIP Fixed Assets - Non-Depreciable
                          </option>
                          <option value="38131">
                            Furniture &amp; Fittings
                          </option>
                          <option value="38132">Office Equipment</option>
                          <option value="38133">Musical Equipments</option>
                          <option value="38134">Computer / POS</option>
                          <option value="38135">
                            Kitchen &amp; Bar Equipments
                          </option>
                          <option value="38136">Renovations</option>
                          <option value="38137">Electrical Fittings</option>
                          <option value="38138">
                            Other Property &amp; Equipment
                          </option>
                        </select>
                      </div>{" "}
                    </div>
                    <div class="select-div col px-1">
                      <div class="input select">
                        <select
                          name="payment_acc"
                          class="csutom_select"
                          id="OrdersPaymentAcc"
                        >
                          <option value="">Current/Sold</option>
                        </select>
                      </div>{" "}
                    </div>
                  </div>
                  <div class="col-lg-1 col px-0 pt-3 pt-lg-0 align-right">
                    <button class="btn btn_btnblue" type="submit">
                      Search
                    </button>
                  </div>
                </div>
              </div>{" "}
            </div>

            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">General Ledger</h4>
                    <div class="row justify-content-between align-items-center w-100 mx-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div class="search-box">
                          <form
                            action="/productions"
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            {" "}
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                            />{" "}
                            <input type="submit" />
                          </form>
                        </div>{" "}
                      </div>
                    </div>

                    <div className="shadowclass mt-0 p-0">
                      <div className="table-responsive">
                        <table className="checklist-table remove-space inventory_table">
                          <thead>
                            <tr>
                              <th>GL Account Name / Period</th>
                              <th>Account Name</th>
                              <th>Trans. Date</th>
                              <th>ID</th>
                              <th>Trans Ref</th>
                              <th>Details</th>
                              <th class="text-right">Debit</th>
                              <th class="text-right">Credit</th>
                              <th class="text-right">Balance</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="order_row">
                              <td colspan="8" height="50">
                                <strong>Please select a GL account</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="show-more-text">
                          <span class="next">Show more transactions...</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default GeneralLedger;
